<template>
  <div>
    <div class="top-box">
      <div class="top-box2 overflow">
        <div class="top-img left">
          <div class="top-title" v-if="$store.state.sunshinePurchase">
            {{ htmlTitle }}
          </div>
        </div>
        <div class="left toptitle">
          <h2>公航旅电子交易中心平台</h2>
        </div>
        <div class="right top-rightimg">
          <img src="@/assets/touxiang_s.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      htmlTitle: "getHtmlTitle"
    })
  },
  mounted() {
    console.log(this.htmlTitle);
  }
};
</script>

<style scoped="scoped" lang="less">
.block-center {
  margin: 0 auto;
}
.top-box {
  border-bottom: 1px solid #e1e8ec;
  height: 70px;
  width: 100%;
  margin-bottom: 20px;
  background: #ffffff;
  .top-box2 {
    width: 1200px;
    height: 100%;
    .block-center;
  }
}
.top {
  &-img {
    width: auto;
    height: 48px;
    margin-top: 11px;
    display: inline-block;
  }
  &-title {
    line-height: 48px;
    text-align: center;
    font-size: 19px;
  }
}
.toptitle {
  letter-spacing: 2px;
  font-size: 24px;
  height: 48px;
  line-height: 50px;
  margin-top: 10px;
  color: #3c4f57;
  padding-left: 30px;
  margin-left: 30px;
  // 嘉峪关注释起来的样式
  border-left: 1px solid #eff4f7;
  // margin-top: 8px;
  // margin-left: 68px;
}
.top-rightimg {
  width: 50px;
  height: 50px;
  margin-top: 10px;
}
</style>
